(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-navigation-collections"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const navCollections = document.querySelector('.navigation-collections');
    const navList = document.querySelector('.navigation-collections__list');
  });

  } catch(e) { console.error(e); }
})();
})();
